import { render, staticRenderFns } from "./HomeFrontPage.vue?vue&type=template&id=11658c5a&"
import script from "./HomeFrontPage.vue?vue&type=script&lang=js&"
export * from "./HomeFrontPage.vue?vue&type=script&lang=js&"
import style0 from "./HomeFrontPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports